import { MainViewLoadingIndicatorState } from './mainViewLoadingIndicator$';

import { connect } from '@ardoq/rxbeach';
import { mainViewLoadingIndicator$ } from './mainViewLoadingIndicator$';
import { LoadingOverlay } from '@ardoq/loader';

export const MainPaneLoader = ({
  isLoading,
}: MainViewLoadingIndicatorState) => {
  return isLoading ? <LoadingOverlay /> : null;
};

export const MainPaneLoaderConnected = connect(
  MainPaneLoader,
  mainViewLoadingIndicator$
);
